import openSocket from 'socket.io-client';
import { getBackendUrl } from '../config';

let socketInstance = null;
let socketToken = null;

const getTokenFromStorage = () => {
  const token = localStorage.getItem('token');
  if (!token) return null;

  try {
    return JSON.parse(token);
  } catch (err) {
    console.error('Token inválido no localStorage');
    return null;
  }
};

const attachBaseListeners = (socket) => {
  if (!socket || socket.__baseListenersAttached) return;

  socket.on('connect', () => {
    console.log('Socket conectado com sucesso - ID:', socket.id);
  });

  socket.on('connect_error', (error) => {
    console.error('Erro na conexão do socket:', error.message);
  });

  socket.on('disconnect', (reason) => {
    console.log('Socket desconectado. Razão:', reason);
  });

  socket.on('reconnect_attempt', (attempt) => {
    console.log(`Tentativa de reconexão ${attempt}`);
  });

  socket.on('reconnect', (attempt) => {
    console.log(`Reconectado na tentativa ${attempt}`);
  });

  socket.on('reconnect_error', (error) => {
    console.error('Erro na reconexão:', error);
  });

  socket.on('reconnect_failed', () => {
    console.error('Falha na reconexão');
  });

  socket.__baseListenersAttached = true;
};

const createSocket = (token) => {
  const socket = openSocket(getBackendUrl(), {
    transports: ['websocket', 'polling'],
    query: { token },
    autoConnect: true,
    forceNew: false,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    timeout: 20000,
    closeOnBeforeunload: false,
  });

  attachBaseListeners(socket);
  socketToken = token;
  socketInstance = socket;

  return socketInstance;
};

const connectToSocket = (forceRecreate = false) => {
  try {
    const token = getTokenFromStorage();
    if (!token) {
      return null;
    }

    const mustRecreate = forceRecreate || (socketInstance && socketToken !== token);

    if (mustRecreate && socketInstance) {
      socketInstance.removeAllListeners();
      socketInstance.disconnect();
      socketInstance = null;
      socketToken = null;
    }

    if (!socketInstance) {
      return createSocket(token);
    }

    if (!socketInstance.connected) {
      socketInstance.connect();
    }

    return socketInstance;
  } catch (err) {
    console.error('Erro ao conectar socket:', err);
    return null;
  }
};

export const reconnectSocketWithLatestToken = () => connectToSocket(true);

export const getSocketInstance = () => socketInstance;

export const disconnectSocket = () => {
  if (!socketInstance) return;

  socketInstance.removeAllListeners();
  socketInstance.disconnect();
  socketInstance = null;
  socketToken = null;
};

export default connectToSocket;
